import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

function CollapsibleFilters({ title = 'Filtros', children, actions, className = '', defaultOpen = true }) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <section className={`filter-panel ${isOpen ? '' : 'filter-panel-collapsed'} ${className}`.trim()}>
            <div className="filter-panel-header">
                <button
                    type="button"
                    className="filter-panel-toggle"
                    onClick={() => setIsOpen((open) => !open)}
                    aria-expanded={isOpen}
                >
                    <span>{title}</span>
                    <FaChevronDown className="filter-panel-chevron" aria-hidden="true" />
                </button>
                {actions && <div className="filter-panel-actions">{actions}</div>}
            </div>
            <div className="filter-panel-body" aria-hidden={!isOpen}>
                {children}
            </div>
        </section>
    );
}

export default CollapsibleFilters;
